export default __webpack_public_path__ + "static/media/standard-blue.184d636a.svg";